/**
 * Internal dependencies
 */
import { createReducer } from 'state/utils';
import { GRAPH_CUBE_META_REQUEST_SUCCESS } from 'state/action-types';

export default createReducer(
	{},
	{
		[GRAPH_CUBE_META_REQUEST_SUCCESS]: (state, action) => {
			return {
				...action.payload.meta,
			};
		},
	},
);
